<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ 'COMPANY.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ion-card class="ion-padding" color="tertiary" button (click)="goPrivacyPage()">
    {{ 'MENU.privacy' | translate }}
  </ion-card>
  <!-- <ion-card class="ion-padding" color="tertiary" button (click)="goDataProtectionPage()">
    {{ 'DATA_PROTECTION.title' | translate }}
  </ion-card> -->
  <ion-card class="ion-padding" color="tertiary" button (click)="goTermPage()">
    {{ 'MENU.term' | translate }}
  </ion-card>
  <!-- <ion-card class="ion-padding" color="tertiary" button (click)="goContactPage()">
    {{ 'CONCTACT.title' | translate }}
  </ion-card>
  <ion-card class="ion-padding" color="tertiary" button (click)="goFaqPage()">
    {{ 'FAQ.title' | translate }}
  </ion-card> -->
</ion-content>
